'use client';

import React from 'react';
import Link from 'next/link';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  showReturnToLetter?: boolean;
}

export default function Breadcrumb({ items, showReturnToLetter = false }: BreadcrumbProps) {
  return (
    <div style={{
      background: 'rgba(6,13,18,0.85)',
      borderBottom: '1px solid rgba(201,168,76,0.1)',
      padding: '8px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 8,
      position: 'sticky',
      top: 64,
      zIndex: 40,
      backdropFilter: 'blur(8px)',
    }}>
      {/* Breadcrumb trail */}
      <nav aria-label="Breadcrumb" style={{ display: 'flex', alignItems: 'center', gap: 0, flexWrap: 'wrap' }}>
        {items.map((item, i) => (
          <React.Fragment key={i}>
            {i > 0 && (
              <span style={{
                fontSize: 9,
                color: 'rgba(201,168,76,0.3)',
                margin: '0 8px',
                letterSpacing: '.05em',
              }}>›</span>
            )}
            {item.href ? (
              <Link
                href={item.href}
                style={{
                  fontSize: 10,
                  color: i === items.length - 1 ? '#c9a84c' : 'rgba(201,168,76,0.5)',
                  textDecoration: 'none',
                  letterSpacing: '.08em',
                  fontFamily: 'monospace',
                  textTransform: 'uppercase',
                  transition: 'color 0.2s',
                }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.color = '#c9a84c'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.color = i === items.length - 1 ? '#c9a84c' : 'rgba(201,168,76,0.5)'; }}
              >
                {item.label}
              </Link>
            ) : (
              <span style={{
                fontSize: 10,
                color: '#c9a84c',
                letterSpacing: '.08em',
                fontFamily: 'monospace',
                textTransform: 'uppercase',
              }}>{item.label}</span>
            )}
          </React.Fragment>
        ))}
      </nav>

      {/* Return to Letter button */}
      {showReturnToLetter && (
        <Link
          href="/open-letter"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            fontSize: 10,
            color: 'rgba(201,168,76,0.7)',
            textDecoration: 'none',
            letterSpacing: '.08em',
            fontFamily: 'monospace',
            textTransform: 'uppercase',
            border: '1px solid rgba(201,168,76,0.2)',
            borderRadius: 3,
            padding: '4px 10px',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
          }}
          onMouseEnter={e => {
            (e.currentTarget as HTMLElement).style.color = '#c9a84c';
            (e.currentTarget as HTMLElement).style.borderColor = 'rgba(201,168,76,0.5)';
            (e.currentTarget as HTMLElement).style.background = 'rgba(201,168,76,0.06)';
          }}
          onMouseLeave={e => {
            (e.currentTarget as HTMLElement).style.color = 'rgba(201,168,76,0.7)';
            (e.currentTarget as HTMLElement).style.borderColor = 'rgba(201,168,76,0.2)';
            (e.currentTarget as HTMLElement).style.background = 'transparent';
          }}
        >
          <span style={{ fontSize: 9 }}>✦</span>
          Return to Letter
        </Link>
      )}
    </div>
  );
}
